module.exports = __webpack_public_path__ + "static/media/hat.f7acbc5a.png";